import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74d3dcf8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-relationship-selector" }
const _hoisted_2 = {
  key: 0,
  value: ""
}
const _hoisted_3 = ["value"]

import { computed } from 'vue'
import { newProfileRelationships, getNewProfileRelationshipText, NewProfileRelationship } from '@/manage/profiles/ProfileManager'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileRelationshipSelector',
  props: {
    modelValue: {},
    disabled: { type: Boolean },
    allowEmpty: { type: Boolean }
  },
  emits: [
  'update:modelValue',
  'focus'
],
  setup(__props: any, { emit }) {

const props = __props;





const selectedValue = computed({
  get() { return props.modelValue },
  set(value) { emit('update:modelValue', value) }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("select", _mergeProps({
      class: "form-select",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedValue).value = $event))
    }, { disabled: props.disabled }, {
      onFocus: _cache[1] || (_cache[1] = ($event: any) => (emit('focus')))
    }), [
      (_ctx.allowEmpty)
        ? (_openBlock(), _createElementBlock("option", _hoisted_2))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(newProfileRelationships), (rel) => {
        return (_openBlock(), _createElementBlock("option", {
          value: rel,
          key: rel
        }, _toDisplayString(_unref(getNewProfileRelationshipText)(rel)), 9, _hoisted_3))
      }), 128))
    ], 16), [
      [_vModelSelect, selectedValue.value]
    ])
  ]))
}
}

})